export default __webpack_public_path__ + "static/write-for-us-41b5a4ed3e5ef2c837d363cb50b91dae.jpg";